import { IDmChuyenNganhActionTypes } from "../../action-types/category/IDmChuyenNganhActions";
import { IDmChuyenNganhReducer } from "../../reducer-model/category/IDmChuyenNganhReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IDmChuyenNganhReducer = {
  status: eReducerStatusBase.is_not_initialization,
  chuyenNganhs: [],
  nganhIdFilter: 0
};
export const chuyenNganhReducer = (
  state: IDmChuyenNganhReducer = iniState,
  action: IDmChuyenNganhActionTypes
): IDmChuyenNganhReducer => {
  switch (action.type) {
    case "CHUYEN_NGANH_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "CHUYEN_NGANH_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        chuyenNganhs: action.payload,
      };
    case "CHUYEN_NGANH_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CHUYEN_NGANH_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        chuyenNganhEditing: action.payload,
      };
    case "CHUYEN_NGANH_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "CHUYEN_NGANH_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "CHUYEN_NGANH_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "CHUYEN_NGANH_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CHUYEN_NGANH_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "CHUYEN_NGANH_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "CHUYEN_NGANH_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CHUYEN_NGANH_CHANGE_NGANH_ID_FILTER":
      return {
        ...state,
        nganhIdFilter: action.payload
      };
    default:
      return state;
  }
};
